import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Toggle from 'react-toggle';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffRfmsReportMissing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      day_off: 0,
      data: null,
      date_start: '',
      date_finish: '',
      applicability_id: '',
      bases_list: [],
      applicabilities_list: [],
      base_id: null,
    };
    
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.searchReports = this.searchReports.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  
  searchReports(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      base_id: this.state.base_id,
      applicability_id: this.state.applicability_id,
      day_off: this.state.day_off,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios-de-fadiga/faltantes', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorios-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            bases_list: responseJson.data.bases_list,
            applicabilities_list: responseJson.data.applicabilities_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.titulo}</h3>
      <hr/>
      <form onSubmit={this.searchReports}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} required maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} required maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                placeholder={this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChange.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.Bases}:</label>
              <Select
                className="form-field-name"
                name="base_id"
                value={this.state.base_id}
                searchable={true}
                placeholder={this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'base_id')}
                options={this.state.bases_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.IncluirFolgaCadastradaAutomaticamente}?</label>
              <br/>
              <Toggle
                checked={this.state.day_off}
                aria-label='No label tag'
                name="day_off"
                onChange={this.handleToggleChange.bind(this, 'day_off')} />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.botaoProcurarRelatorios}</button>
        </div>
      </form>
      <hr/>
      {self.state.data !== null ? 
        <div>
          <h3 className="page-title">{this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.tituloListaDeRelatOriosDeFadigasFaltantes}</h3>
          <hr/>
          <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.tabela.semReportesFaltantes}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

            <TableHeaderColumn isKey={true} dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.tabela.Nome}</TableHeaderColumn>
            <TableHeaderColumn dataField="date" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.tabela.Data}</TableHeaderColumn>
            <TableHeaderColumn dataField="situation" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.tabela.Situacao}</TableHeaderColumn>
          </BootstrapTable>
        </div>
      : ""}
    </div>
  </div>
</div>
    );
  }
}

export default StaffRfmsReportMissing;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/StaffRfmsReportMissing.js